/**
 * 忘记密码
 */
import React from 'react'
import { FormPro, Input, Button } from '@roo/roo'
import { useTranslation } from '@sailor/i18n-web'
import styles from './index.module.less'
import { useRequest } from 'ahooks'
import PageBox from '@/components/PageBox'
import { onFormCheckFail } from '@/common/utils'
import PasswordInput, { getPswError } from '@/components/PasswordInput'
import { useNavigate } from 'react-router'
import { failToast, successToast } from '@/common/utils/toast'
import PswIcon from './components/PswIcon'
import { useRecoilValue } from 'recoil'
import { loginUserInfo } from '@/common/recoil/atom/userAtom'
import { editPassword } from './api'
import { getLoginPublicKey } from '../login/api'
import { encryptPsw } from '../login/utils'


const ResetPassword = () => {
  const { t } = useTranslation()
  const [changePswForm] = FormPro.useForm()
  const navigate = useNavigate()
  const userInfo = useRecoilValue(loginUserInfo)
  const currentEmail = userInfo?.adminInfo?.email || ''

  // 提交
  const { loading: submitLoading, run: verifyCode } = useRequest(async () => {
    const values = await changePswForm.getFieldsValue()
    const error = getPswError(values.newPassword)
    if (error) {
      failToast(error)
      return
    }
    const publicKey = await getLoginPublicKey()
    const oldPwd = await encryptPsw(values.oldPsw, publicKey)
    const newPwd = await encryptPsw(values.newPassword, publicKey)
    await editPassword({
      userName: currentEmail,
      oldPwd,
      newPwd,
    })
    successToast(t('e_pc_password_change_success', '密码修改成功'))
    navigate('/login')

  }, { manual: true })

  const newPassword = FormPro.useWatch('newPassword', changePswForm)
  const oldPassword = FormPro.useWatch('oldPsw', changePswForm)


  return (
    <PageBox>
      <div className={styles.container}>
        <div>
          <div style={{ textAlign: 'center',  paddingBottom: '12px' }}>
            <div style={{ fontSize: '24px', fontWeight: '700', color: '#1f1f1f' }}> {t('e_pc_modify_password', '修改密码')} </div>
            <div > {t('e_pc_set_new_password_for_email', { email: currentEmail }) || `为邮箱${currentEmail}设置新密码`} </div>
          </div>
          <FormPro
            name="resetForm"
            onFinish={verifyCode}
            onFinishFailed={onFormCheckFail}
            labelCol={{ span: 12 }}
            wrapperCol={{ span: 12 }}
            layout="vertical"
            form={changePswForm}
          >
            <FormPro.Item
              name="oldPsw"
              validateTrigger={['onBlur']}
              label={t('e_pc_current_password', '当前密码')}
              rules={[
                { required: true, message: t('e_pc_enter_current_password', '请输入当前密码	') },
              ]}
            >
              <Input placeholder={t('e_pc_enter_current_password', '请输入当前密码	')} type="password" prefix={<PswIcon />} />
            </FormPro.Item>
            <FormPro.Item
              name="newPassword"
              label={t('e_pc_new_password', '新密码')}
              rules={[
                {
                  validator: (_: any, value: string) => {
                    if (value && value === oldPassword) {
                      return Promise.reject(new Error(t('e_pc_new_password_same_as_current', '新密码不能与当前密码相同')))
                    }
                    return Promise.resolve()
                  },
                },
              ]}
            >
              <PasswordInput/>
            </FormPro.Item>
            <FormPro.Item
              name="confirmPsw"
              validateTrigger={['onBlur']}
              label={t('e_pc_confirm_password', '确认密码')}
              rules={[
                {
                  validator: (_: any, value: string) => {
                    if (!value) {
                      return Promise.reject(new Error(t('e_pc_re_enter_new_password', '请再次输入新密码')))
                    }
                    if (value !== newPassword) {
                      return Promise.reject(new Error(t('e_pc_password_not_same', '两次输入的密码不一致')))
                    }
                    return Promise.resolve()
                  },
                },
              ]}
            >
              <Input placeholder={t('e_pc_re_enter_new_password', '请再次输入新密码')} type="password" prefix={<PswIcon />} />
            </FormPro.Item>
            <FormPro.Item>
              <Button type="brand" htmlType="submit" style={{ width: '100%' }} loading={submitLoading} disabled={submitLoading}>
                {t('e_pc_confirm_change', '确认修改')}
              </Button>
            </FormPro.Item>
          </FormPro>
        </div>
      </div>
    </PageBox>
  )
}

export default ResetPassword